<template>
  <b-modal title="Informações Sobre a Saída" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="10">
          <b-form-group label="Cliente:" label-for="cliente" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="cliente" v-model="editing.cliente" />
          </b-form-group>
        </b-col>

        <b-col cols="1">
          <b-form-select v-model="selecionado">
            <b-form-select-option v-for="cliente of clienteStore.clientes" v-bind:key="cliente.id" :value="cliente"
              >{{ cliente.nome }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="descricao" label-cols-sm="3" label-align-sm="right">
            <b-form-textarea v-model="editing.descricao" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Nota Fiscal:" label-for="fiscal" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="fiscal" v-model="editing.notafiscal" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Recebedor:" label-for="receb" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="receb" v-model="editing.recebeu" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Setor:" label-for="setor" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="setor" v-model="editing.setor" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Enviou:" label-for="entr" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="entr" v-model="editing.entregou" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Protocolo:" label-cols-sm="3" label-align-sm="right">
            <b-form-file type="file" class="text-left mt-1" v-model="arquivo" placeholder="Solte aqui .jpg" accept=".jpg" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useEntradaSaidaStore } from "@/stores/EntradaSaidaStore";
import { useClienteStore } from "@/stores/ClienteStore";
import Saida from "@/models/Saida";
import Notificacao from "@/models/Notificacao";
import Files from "@/http/files";

export default {
  name: "ModalDeEdicaoDeSaida",

  data() {
    return {
      show: false,
      selecionado: null,
      editing: new Saida(0, "Nova Entrada", "", new Date(), "", "", "", ""),
      files: new Files(this.$http),
      arquivo: null,
    };
  },

  watch: {
    selecionado: function (cliente) {
      this.editing.cliente = cliente.nome;
    },
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.entradaSaidaStore.ALTERAR_SAIDA(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Saída de equipamento salva no SGCQ com sucesso!", "Excelente!", "success"));
          if (this.arquivo != null) {
            const filename = this.editing.id + ".jpg";
            let formData = new FormData();
            formData.append("name", this.arquivo.name);
            formData.append("file", this.arquivo);
            this.files.uploadProtocolo(filename, formData);
          }
        });
      } else {
        this.entradaSaidaStore
          .CADASTRAR_SAIDA(this.editing)
          .then(() =>
            this.store.NOTIFICAR(new Notificacao("Saída de equipamento salva no SGCQ com sucesso!", "Excelente!", "success"))
          );
      }
      this.show = !this.show;
    },

    call(saida) {
      this.show = !this.show;
      this.editing = saida;
    },
  },

  setup() {
    const store = useSgcqStore();
    const entradaSaidaStore = useEntradaSaidaStore();
    const clienteStore = useClienteStore();

    return {
      store,
      entradaSaidaStore,
      clienteStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
